import { Button, Col, Flex, Row, Space, Switch, Typography } from "antd"
import GCalendar from "assets/icons/google-calendar.svg"
import Google from "assets/icons/google.svg"
import PropTypes from "prop-types"
import { Icon } from "ui/Icon"
import { SettingsTitle } from "../ProSettings/SettingsTitle"
import styles from "./GoogleCalendar.module.css"
import useActiveGuide from "hooks/useActiveClient"
import { SyncOutlined } from "@ant-design/icons"
import { updateGoogleCalendarAccount } from "store/google-calendar"
import { useDispatch } from "react-redux"
import { toaster } from "components/common/Toast"
const { Text } = Typography

export const GoogleCalendarAccounts = ({
  googleAccounts,
  t,
  handleAddCalendarAccount,
  handleDeleteCalendarAccount,
  handleGoogleCalendarConnection
}) => {
  const { isActive: active } = useActiveGuide()
  const dispatch = useDispatch()
  const handleSyncCalendar = (accountId) => {
    // Trigger sync API (PUT) with id in payload
    dispatch(updateGoogleCalendarAccount(accountId, { id: accountId })).then((res) => {
      toaster.success(res?.message)
    })
  }
  return (
    <Row gutter={[16, 16]} className={styles.googleCalendarAccounts}>
      <Col span={24}>
        <div>{t("google_calendar.availability")}</div>
        <div className={styles.label}>{t("google_calendar.title")}</div>
      </Col>
      <Col span={24}>
        <div className={styles.calendarSyncContent}>
          {googleAccounts?.length ? (
            <>
              <Flex justify="space-between" align="center" className={styles.hadAccount}>
                <Text>
                  {t("google_calendar.hadAccount")} {googleAccounts?.length}
                </Text>
                <Button type="primary" onClick={active ? handleAddCalendarAccount : undefined} disabled={!active}>
                  {t("google_calendar.add_account")}
                </Button>
              </Flex>
              <Flex vertical gap={4} className={styles.accountCardContainer}>
                {googleAccounts?.map((account) => (
                  <div key={account.id}>
                    <Flex justify="space-between" align="center" className={styles.accountCardContent}>
                      <Flex gap={25} align="center">
                        <img alt="Google Calendar" src={GCalendar} width={40} />
                        <div>
                          <strong>{t("global.google")}</strong>
                          <div>{account.email}</div>
                        </div>
                      </Flex>
                      <Flex gap={25} align="center">
                        <Switch
                          checked={account?.active}
                          onChange={() => {
                            handleGoogleCalendarConnection(account?.id, account?.active)
                          }}
                          style={{ backgroundColor: account?.active ? "#1d72f4" : "#ccc" }}
                        />
                        <SyncOutlined
                          disabled={!account?.active}
                          rotate={180}
                          onClick={account?.active ? () => handleSyncCalendar(account?.id) : undefined}
                          className={account?.active ? styles.syncIcon : `${styles.syncIcon} ${styles.syncIconDisabled}`}
                        />
                        <Icon
                          className="ml-xxs"
                          name="Trash"
                          width={20}
                          height={20}
                          onClick={() => handleDeleteCalendarAccount(account?.id, account?.email)}
                          style={{ cursor: "pointer" }}
                        />
                      </Flex>
                    </Flex>
                  </div>
                ))}
              </Flex>
            </>
          ) : (
            <div className={styles.noAccountCard}>
              <div className={styles.gTitle}>
                <SettingsTitle title={t("google_calendar.label")} subTitle={t("google_calendar.subtitle")} />
              </div>
              <div className={styles.gIcon}>
                <Space>
                  <img alt="google" src={Google} width={30} />
                  <Text>{t("global.google")}</Text>
                </Space>
              </div>
              <Flex justify="space-between" align="center" className={styles.gCalendar}>
                <Flex gap={25} align="center">
                  <img alt="Google Calendar" src={GCalendar} width={30} />
                  <div>
                    <strong>{t("global.google")}</strong>
                    <div>{t("global.calendar")}</div>
                  </div>
                </Flex>
                <Button type="primary" onClick={active ? handleAddCalendarAccount : undefined} disabled={!active}>
                  {t("global.connect")}
                </Button>
              </Flex>
            </div>
          )}
        </div>
      </Col>
    </Row>
  )
}

// ✅ Add PropTypes validation
GoogleCalendarAccounts.propTypes = {
  googleAccounts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      active: PropTypes.bool.isRequired
    })
  ).isRequired,
  t: PropTypes.func.isRequired,
  handleAddCalendarAccount: PropTypes.func.isRequired,
  handleDeleteCalendarAccount: PropTypes.func.isRequired,
  handleGoogleCalendarConnection: PropTypes.func.isRequired
}
